import { NotificationsMenuComponent } from "./notificationsMenu";

export const NotificationsMenu = NotificationsMenuComponent;
